import React from 'react';
import './App.css';
import Find from './components/Find/Find';
import Header from './components/Header/Header';


function App() {
  return (
    <div className="App">
      <Header></Header>
      <Find></Find>
    </div>
  );
}

export default App;
